module.exports = __webpack_public_path__ + "static/media/chart-bar-off.4b59e62a.svg";